import { render } from "./ModalCancelProposal.vue?vue&type=template&id=2a49dd8d&scoped=true"
import script from "./ModalCancelProposal.vue?vue&type=script&lang=js"
export * from "./ModalCancelProposal.vue?vue&type=script&lang=js"

import "./ModalCancelProposal.vue?vue&type=style&index=0&id=2a49dd8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a49dd8d"]])

export default __exports__